import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SubtitlePrimary } from '../Base';
import PromoContent from './PromoContent';
import Spacing from '../Spacing';

const StyledContent = styled.div`
  margin-bottom: ${p => p.theme.spacing(4)};
  padding: ${p => p.theme.spacing(2)};
  padding-bottom: ${p => p.theme.spacing(3)};
  background-color: ${p => p.theme.colours.grey_50};
`;

const StyledDivider = styled.div`
  display: flex;

  &:before,
  &:after {
    content: '';
    flex: 1 1;
    border-bottom: 1px solid ${p => p.theme.colours.grey_400};
    margin: auto;
  }

  &:before {
    margin-right: ${p => p.theme.spacing(1)};
  }

  &:after {
    margin-left: ${p => p.theme.spacing(1)};
  }
`;

const PromoFrameworkTwo = props => {
  const { groupTitle, promos } = props;

  return (
    <StyledContent>
      {groupTitle && (
        <Spacing bottom={2}>
          <SubtitlePrimary>{groupTitle}</SubtitlePrimary>
        </Spacing>
      )}
      {promos.map((promo, index) => {
        const { title, subtitle, description } = promo;

        return (
          <Fragment key={title}>
            <PromoContent
              title={title}
              subtitle={subtitle}
              description={description}
            />
            {promos.length - 1 > index && (
              <Spacing bottom={2}>
                <StyledDivider>or</StyledDivider>
              </Spacing>
            )}
          </Fragment>
        );
      })}
    </StyledContent>
  );
};

PromoFrameworkTwo.propTypes = {
  groupTitle: PropTypes.string,
  promos: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      description: PropTypes.string
    })
  )
};

export default PromoFrameworkTwo;
